import React from "react";
import styled from "styled-components";
import theme from "../../../styles/theme";
import bodyStyles from "./bodyStyles";

const {
	breakPoints: { mobileFirstScreenQuery },
} = theme;

const Body2 = styled.p(
	bodyStyles,
	`
  color: #333333;
  font-size: 18px;
  line-height: 29px;

  ${mobileFirstScreenQuery.medium} {
    font-size: 20px;
    line-height: 32px;
  }
}`
);
export default ({ children, ...props }) => <Body2 {...props}>{children}</Body2>;
